import { Injectable } from '@angular/core';

import { GfoService, ColumnFilter, Gfo } from './gfo.service';

@Injectable()
export class ColumnFilterService {

	constructor(
		private gfoService: GfoService
	) { }

	getColumnFiltersGfo(columnFilters: {[name: string]: ColumnFilter}): Gfo {
		const filters = [];
		for (const filter of Object.keys(columnFilters)) {
			if (columnFilters[filter]) {
				filters.push(columnFilters[filter]);
			}
		}
		return this.gfoService.getGfo(
			this.gfoService.filterLogics.and,
			filters,
			null,
			null
		);
	}
}
